import React from "react";
import "./index.less";
import CornerImg from "imgs/corner.svg";

export default function App({ width, height, children }) {
    return (
        <div className="square-wrap" style={{ width: `${width || 200}px`, height: `${height || width || 200}px` }}>
            <img className="square-corner top-left" src={CornerImg} />
            <img className="square-corner top-right" src={CornerImg} />
            <img className="square-corner bottom-left" src={CornerImg} />
            <img className="square-corner bottom-right" src={CornerImg} />
            <div className="square-content">{children}</div>
        </div>
    )
}